import React from "react"
import { Button } from "reactstrap"
import PropTypes from "prop-types"
import useDisclosure from "hooks/useDisclosure"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"
import DeleteModal from "components/Common/DeleteModal"
import { deleteDocument, extractDocument } from "api/docApi"

function DocumentRowAction({ row }) {
  const queryClient = useQueryClient()
  const deleteModal = useDisclosure()

  // delete contract mutation
  const deleteMutation = useMutation({
    mutationFn: () => deleteDocument(row.original.id),
    onSuccess: () => {
      queryClient.invalidateQueries("documents")
      deleteModal.close()
    },
    onError: error => toast.error(error),
  })

  const extractMutation = useMutation({
    mutationFn: () => extractDocument(row.original.id),
    onSuccess: () => toast.success("successfully done"),
    onError: error => toast.error(error),
  })

  return (
    <React.Fragment>
      {deleteModal.isOpen ? (
        <DeleteModal
          show={deleteModal.isOpen}
          onDeleteClick={deleteMutation.mutate}
          onCloseClick={deleteModal.close}
          isLoading={deleteMutation.isPending}
        />
      ) : null}
      <div className="d-flex gap-2">
        <Button
          tag={"a"}
          target="blink"
          href={row.original.upload_file}
          size="sm"
          color="soft-primary"
        >
          <i className="bx bx-show"></i>
        </Button>
        <Button
          size="sm"
          color="soft-success"
          onClick={extractMutation.mutate}
          disabled={extractMutation.isPending}
        >
          <i className="bx bx-file-find"></i>
        </Button>
        <Button size="sm" color="soft-danger" onClick={deleteModal.open}>
          <i className="bx bx-trash"></i>
        </Button>
      </div>
    </React.Fragment>
  )
}
DocumentRowAction.propTypes = {
  row: PropTypes.object,
}
export default DocumentRowAction
